import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/contracts/actions/agreement.actions';
import { AgreementActionTypes } from '@appStore/contracts/actions/agreement.actions';
import { AgreementsService } from '@appStore/contracts/services/agreements.service';


@Injectable()
export class AgreementEffects{
    constructor(private agreementService: AgreementsService, private actions$: Actions){}

    createAdditionAgreement$ = createEffect(() =>{
        return this.actions$.pipe(
            ofType(AgreementActionTypes.CreateAdditionAgreement),
            exhaustMap((action: actions.CreateAdditionAgreement) => {
                return this.agreementService.createAdditionAgreement(action.payload).pipe(
                    map(agreementId => new actions.CreateAdditionAgreementSuccess(agreementId)),
                    catchError(error => of(new actions.CreateAdditionAgreementFail(error)))
                );
            })
        );
    });

    getAgreementLink$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AgreementActionTypes.AgreementLinkLoad),
            exhaustMap((action: actions.AgreementLinkLoad) => {
                return this.agreementService.getAgreementLink(action.agreementId).pipe(
                    map(link => new actions.AgreementLinkLoadSuccess(link)),
                    catchError(error => of(new actions.AgreementLinkLoadFail(error)))
                );
            })
        );
    });

    getIscreateAdditionAgreementCreated$ = createEffect(() =>{
        return this.actions$.pipe(
            ofType(AgreementActionTypes.IsAdditionAgreementCreated),
            exhaustMap((action: actions.IsAdditionAgreementCreated) => {
                return this.agreementService.getIsAdditionAgreementCreated(action.payload).pipe(
                    map(created => new actions.IsAdditionAgreementCreatedSuccess(created)),
                    catchError(error => of(new actions.IsAdditionAgreementCreatedFail(error)))
                );
            })
        );
    });
}
